import { graphql } from "relay-runtime"

export const chConfirmBetterDocRejection = graphql`
  mutation chConfirmBetterDocRejectionMutation($input: Ch_confirmBetterDocRejectionInput!) {
    confirmBetterDocRejection: ch_confirmBetterDocRejection(input: $input) {
      ProgressNoteMutationOutput: ch_ProgressNoteMutationOutput {
        progressNote {
          id
          updatedAt
          betterDoc {
            rejectionReason
          }
        }
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
